import { timeframeMinutes } from "@/lib/new-backtest";

/** Offered when the exchange's own timeframes can't be loaded. */
const FALLBACK_TIMEFRAMES = ["1m", "3m", "5m", "15m", "30m", "1h", "4h"];

/**
 * Timeframes the Bar Magnifier can use for a chart timeframe: shorter ones
 * that divide it evenly, shortest first. Orders then fill along those smaller
 * candles inside each bar instead of an assumed path.
 */
export function barMagnifierOptions(timeframe: string | undefined, timeframes: string[] = FALLBACK_TIMEFRAMES): string[] {
  const main = timeframeMinutes(timeframe || "");
  if (!main) return [];
  const list = timeframes.length ? timeframes : FALLBACK_TIMEFRAMES;
  return [...new Set(list)]
    .map((tf) => ({ tf, mins: timeframeMinutes(tf) }))
    .filter((x): x is { tf: string; mins: number } => !!x.mins && x.mins < main && main % x.mins === 0)
    .sort((a, b) => a.mins - b.mins)
    .map((x) => x.tf);
}

/**
 * The magnifier a run can actually use: the saved one while it still fits the
 * chart timeframe, else none (the chart timeframe may have changed since).
 */
export function effectiveBarMagnifier(timeframe: string | undefined, magnifier: string | null | undefined): string {
  const m = String(magnifier || "").trim();
  if (!m) return "";
  const main = timeframeMinutes(timeframe || "");
  const sub = timeframeMinutes(m);
  return main && sub && sub < main && main % sub === 0 ? m : "";
}
